export default __webpack_public_path__ + "static/media/Icon_bus.299c909b.svg";